module.exports = __webpack_public_path__ + "img/light.fe23b14.svg";